import type { ReactNode } from "react"
import { useAuth } from "../auth"

export function Brand() {
	return (
		<span className="brand">
			<span className="brand-mark" aria-hidden />
			walkie
		</span>
	)
}

export function SignInScreen({ note }: { note?: ReactNode }) {
	const auth = useAuth()
	const SignIn = auth.adapter?.SignIn
	return (
		<div className="page">
			<div className="card">
				<div className="card-h">
					<Brand />
				</div>
				{note && <div className="dim">{note}</div>}
				{auth.error ? (
					<div className="form-error" role="alert">
						{auth.error}
					</div>
				) : SignIn ? (
					<SignIn onSignedIn={auth.completeSignIn} />
				) : null}
			</div>
		</div>
	)
}
